export function setCookie(name: string, value: string, days: number) {
  const d = new Date();
  d.setTime(d.getTime() + days * 86400 * 1000);
  const expires = d.toUTCString();
  const secure = location.protocol === "https:" ? "Secure;" : "";
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax;${secure}`;
}

export function getCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]*)`));
  return m ? decodeURIComponent(m[2]) : null;
}

export function deleteCookie(name: string) {
  setCookie(name, "", -1);
}
